import { onMounted, onUnmounted, ref } from 'vue'
import { MOBILE_MAX_WIDTH } from '@/utils/responsiveWidgetSize'

/**
 * True when viewport matches page-builder mobile breakpoint (≤767.98px).
 * Used for mobile-only overrides (e.g. columnsMobile), not for gallery layout mode.
 */
export function useViewportMobile(query = `(max-width: ${MOBILE_MAX_WIDTH})`) {
  const isMobile = ref(
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  )

  let mq: MediaQueryList | null = null
  const update = () => {
    if (mq) isMobile.value = mq.matches
  }

  onMounted(() => {
    mq = window.matchMedia(query)
    update()
    mq.addEventListener('change', update)
  })

  onUnmounted(() => {
    mq?.removeEventListener('change', update)
  })

  return isMobile
}
